import React from 'react';

export default function NotFoundPage({ slug }) {
  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'DM Sans, sans-serif', color: '#f5f0e8', padding: '2rem', textAlign: 'center'
    }}>
      <div style={{ fontSize: '5rem', marginBottom: '1.5rem' }}>🍽️</div>
      <h1 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', color: '#fff', marginBottom: '1rem' }}>
        Restaurant Not Found
      </h1>
      <p style={{ color: 'rgba(255,255,255,0.5)', marginBottom: '2rem', maxWidth: '400px', lineHeight: '1.7' }}>
        We couldn't find a restaurant with the subdomain <strong style={{ color: '#c8a96e' }}>{slug}</strong>.
        <br />Try visiting a valid menu URL or check your link.
      </p>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a href="/?restaurant=yasmin" style={{
          padding: '0.9rem 1.75rem', background: '#c8a96e', border: 'none', borderRadius: '12px',
          color: '#fff', fontFamily: 'DM Sans, sans-serif', fontWeight: '700', textDecoration: 'none'
        }}>Try Yasmin Bistro</a>
        <a href="/?restaurant=luna" style={{
          padding: '0.9rem 1.75rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: '12px', color: '#fff', fontFamily: 'DM Sans, sans-serif', textDecoration: 'none'
        }}>Try Luna Coffee</a>
        <a href="/business/login" style={{
          padding: '0.9rem 1.75rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: '12px', color: '#fff', fontFamily: 'DM Sans, sans-serif', textDecoration: 'none'
        }}>Register Your Business</a>
      </div>
    </div>
  );
}
